import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "assets/css/index.scss";
import App from "application/app";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { PAYPAL_CLIENT_ID } from "application/constants/app-constants";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getCurrency from "module/functions/getCurrency";
import getCountry from "module/functions/getCountry";
import getLang from "module/functions/getLang";

const localeMap = {
  fr: "fr_FR",
  en: "en_GB",
};
const country = getCountry();
const lang = getLang() || country || navigator.language || navigator.userLanguage;
const language = lang ?? "en";
const countries = ["fr", "en"];
const locale = language === "en" || !countries.includes(language) ? "en_GB" : localeMap[language];

const initialOptions = {
  "client-id": PAYPAL_CLIENT_ID[country === "fr" ? "fr" : "gb"] ?? PAYPAL_CLIENT_ID,
  currency: getCurrency(),
  intent: "capture",
  locale,
};

ReactDOM.render(
  <PayPalScriptProvider options={initialOptions}>
    <ToastContainer />
    <App />
  </PayPalScriptProvider>,
  document.getElementById("root")
);
